import { createAsyncAtom } from '../../lib/state';

const avnuDisabledLiquiditySourcesAtom = createAsyncAtom<string[]>(async () => []);

export default avnuDisabledLiquiditySourcesAtom;
